import * as React from "react";

const SvgIcnAlertError = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.497 3.02l7.483 7.483a2.117 2.117 0 010 2.994l-7.483 7.483a2.117 2.117 0 01-2.994 0L3.02 13.497a2.117 2.117 0 010-2.994l7.483-7.483a2.117 2.117 0 012.994 0zM13.2 15.6a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0zm-1.212-7.2h.024c.733.009 1.287.71 1.173 1.493l-.513 2.685c-.05.355-.334.622-.668.622h-.008c-.334 0-.62-.267-.668-.622l-.513-2.685C10.7 9.11 11.263 8.4 11.988 8.4z"
            fill="currentcolor"
        />
    </svg>
);

export default SvgIcnAlertError;
